import React from 'react'
import PatientSearchModal from './PatientSearchModal'

const PatientVisitSearchModal = (props) => <PatientSearchModal {...props} visitMode />

export default PatientVisitSearchModal
